import { render, staticRenderFns } from "./ProjectsForm.vue?vue&type=template&id=58bd4ab7&scoped=true&"
import script from "./ProjectsForm.vue?vue&type=script&lang=js&"
export * from "./ProjectsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd4ab7",
  null
  
)

export default component.exports